import React from 'react';
import ShopNavBar from '../../components/ShopNavBar'
import StatsCard from '../../components/shop/analytics/StatsCard';
import JobOverview from '../../components/shop/analytics/JobOverview';
import { useAuth } from '../../contexts/AuthContext';
import { useShopAnalytics } from '../../hooks/useShopAnalytics';
import CustomerActivityChart from '../../components/shop/analytics/CustomerActivityChart';
import FilesOverviewChart from '../../components/shop/analytics/FilesOverviewChart';

const Analytics = () => {
    const { currentUser } = useAuth();
    const {
        completedJobs,
        ongoingJobs,
        totalFiles,
        totalCustomers,
        customerActivityData,
        filesOverviewData,
    } = useShopAnalytics();

    const overviewCompletedJobs = completedJobs;
    const overviewOngoingJobs = ongoingJobs;

    const statsData = [
        {
            id: 1,
            value: overviewCompletedJobs,
            label: "Completed Jobs",
            trend: "+2%",
            color: "#059669",
            bgColor: "#ecfdf5",
            icon: (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="w-[18px] h-[18px]"
                >
                    <circle cx="12" cy="12" r="10"></circle>
                    <path d="m9 12 2 2 4-4"></path>
                </svg>
            ),
        },
        {
            id: 2,
            value: overviewOngoingJobs,
            label: "Ongoing Jobs",
            trend: "+2%",
            color: "#ff5323",
            bgColor: "#fff0ec",
            icon: (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="w-[18px] h-[18px]"
                >
                    <circle cx="12" cy="12" r="10"></circle>
                    <polyline points="12 6 12 12 16 14"></polyline>
                </svg>
            ),
        },
        {
            id: 3,
            value: totalFiles,
            label: "Total Files",
            trend: "+3%",
            color: "#d4850a",
            bgColor: "#fef9ee",
            icon: (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="w-[18px] h-[18px]"
                >
                    <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z" />
                    <path d="M14 2v4a2 2 0 0 0 2 2h4" />
                </svg>
            ),
        },
        {
            id: 4,
            value: totalCustomers,
            label: "Total Customers",
            trend: "+3%",
            color: "#7c3aed",
            bgColor: "#f3f0ff",
            icon: (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="w-[18px] h-[18px]"
                >
                    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
                    <circle cx="9" cy="7" r="4"></circle>
                </svg>
            ),
        },
    ];

    return (
        <div className='bg-background min-h-full flex flex-col font-["Plus_Jakarta_Sans",sans-serif]'>
            <ShopNavBar type={currentUser?.type || "shop"} />
            <main className='flex-1 max-w-[1200px] mx-auto w-full px-[16px] md:px-[40px] py-[24px] md:py-[32px] pb-[80px] md:pb-[40px]'>
                <div>
                    <div className="mb-[24px]">
                        <h1 className="font-semibold text-[24px] md:text-[28px] text-[#212326] mb-[4px]">
                            Analytics
                        </h1>
                        <p className="font-medium text-[14px] text-[#717182]">
                            Track your shop's performance and customer activity.
                        </p>
                    </div>
                </div>

                {/* Stats Cards */}
                <div className="grid grid-cols-2 lg:grid-cols-4 gap-[12px] mb-[24px]">
                    {statsData.map((item) => (
                        <StatsCard item={item} />
                    ))}
                </div>

                <div className="grid grid-cols-1 lg:grid-cols-[2fr_1fr] gap-[12px] mb-[12px]">
                    {/* Charts */}
                    <FilesOverviewChart data={filesOverviewData} />

                    <JobOverview
                        completedJobs={overviewCompletedJobs}
                        ongoingJobs={overviewOngoingJobs}
                    />

                </div>

                <CustomerActivityChart data={customerActivityData} />

            </main>
        </div>
    );

}

export default Analytics;